import { Alignment, HorizontalPadding, TopPadding } from '@easeltv/client-sdk';

import DumbFooterTextBlock from './FooterTextBlock.dumb';

/* ---------------------------------- Types --------------------------------- */

export interface FooterTextBlockI {
    /** copy to be displayed */
    text: string;

    /** controls copy and container alignment inside the footer */
    alignment: Alignment;

    /** controls left and right spacing of the copy */
    horizontalPadding: HorizontalPadding;

    /** controls amount of space above the copy */
    topPadding: TopPadding;
}

/* -------------------------------- Component ------------------------------- */

/**
 * FooterTextBlock
 *
 * @param props FooterTextBlockI
 * @returns JSX.Element
 */
const FooterTextBlock = ({
    text,
    alignment,
    horizontalPadding,
    topPadding,
}: FooterTextBlockI) => (
    <DumbFooterTextBlock
        text={text}
        alignment={alignment}
        horizontalPadding={horizontalPadding}
        topPadding={topPadding}
    />
);

/* --------------------------------- Export --------------------------------- */

export default FooterTextBlock;
